// extracted by mini-css-extract-plugin
export default {"Backdrop":"Loader_Backdrop__wedu8","Loader":"Loader_Loader__lhSmy"};